export default {
  // Navigation
  nav_home: 'Startseite',
  nav_shopping_guide: 'Einkaufs-Guide',
  nav_categories: 'Kategorien',
  nav_guides: 'Leitfäden',
  nav_reviews: 'Bewertungen',
  nav_shipping: 'Versand',
  nav_qc: 'QC',
  nav_safety: 'Sicherheit',
  nav_faq: 'FAQ',
  nav_contact: 'Kontakt',
  nav_language: 'Sprache',

  // Hero
  hero_eyebrow: 'UNABHÄNGIGE RESSOURCE',
  hero_title: 'CSSBuy Spreadsheet: Produkte finden, vergleichen und besser recherchieren',
  hero_subtitle: 'Ein unabhängiger Guide zu CSSBuy Spreadsheet, Produkten, QC, Versand, Lager und praktischen Einkaufstipps.',
  cta_explore: 'CSSBuy Spreadsheet entdecken',
  cta_guide: 'CSSBuy Guide lesen',
  cta_main_site: 'Zur Hauptseite',
  cta_buy_now: 'Jetzt kaufen',
  cta_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',

  // Categories
  categories_title: 'Produktkategorien erkunden',
  categories_subtitle: 'Stöbern Sie nach Kategorie und finden Sie, was Sie brauchen, über unseren organisierten Ressourcen-Hub.',
  categories_all: 'Alle Kategorien',
  category_shoes: 'Schuhe',
  category_hoodies: 'Hoodies/Pullover',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jacken',
  category_pants: 'Hosen/Shorts',
  category_headwear: 'Kopfbedeckungen',
  category_sets: 'Sets',
  category_underwear: 'Unterwäsche',
  category_jersey: 'Trikots',
  category_accessories: 'Accessoires',
  category_bags: 'Taschen',
  category_belts: 'Gürtel',
  category_perfumes: 'Parfums',
  category_other: 'Sonstiges',

  // What is CSSBuy Spreadsheet
  what_is_title: 'Was ist CSSBuy Spreadsheet?',
  what_is_text: 'Das CSSBuy Spreadsheet ist eine praktische Möglichkeit, Produkte, Kategorien, Verkäuferinformationen und Kaufreferenzen zu organisieren und zu recherchieren. Wir haben unabhängige Guides zusammengestellt, um Ihnen zu helfen, Produkte, QC, Versand, Lager und andere wichtige Aspekte vor dem Kauf zu verstehen.',

  // Value props
  value_title: 'Alles, was Sie vor dem Kauf wissen müssen',
  value_spreadsheet: 'Finden und organisieren Sie Produktinformationen.',
  value_qc: 'Lernen Sie, wie Sie Fotos und Details vor dem Versand analysieren.',
  value_shipping: 'Verstehen Sie Kosten, Methoden und Faktoren, die den Versand beeinflussen.',
  value_warehouse: 'Verstehen Sie Lagerung, Inspektion und Konsolidierung.',
  value_review: 'Konsultieren Sie unabhängige Bewertungen und Informationen.',
  value_safety: 'Lernen Sie, verdächtige Links, Betrug und gefälschte Konten zu erkennen.',

  // How it works
  how_title: 'Wie man CSSBuy Spreadsheet verwendet',
  how_step1: 'Suchen Sie nach einem Produkt oder einer Kategorie.',
  how_step2: 'Vergleichen Sie die Informationen.',
  how_step3: 'Überprüfen Sie Verkäufer und Details.',
  how_step4: 'Prüfen Sie QC.',
  how_step5: 'Analysieren Sie Versandkosten und -methoden.',
  how_step6: 'Bestätigen Sie aktuelle Informationen.',
  how_step7: 'Fahren Sie bei Bedarf zur Hauptwebsite fort.',
  how_cta: 'Recherche starten',

  // Articles
  articles_title: 'Beliebte Guides & Artikel',
  articles_subtitle: 'Tiefgehende Ressourcen, um Ihnen bei fundierten Entscheidungen zu helfen.',
  article_spreadsheet_guide: 'CSSBuy Spreadsheet Komplett-Guide',
  article_spreadsheet_guide_desc: 'Ein umfassender Leitfaden zum Verständnis und effektiven Nutzen von CSSBuy Spreadsheet.',
  article_review: 'CSSBuy Bewertung 2026',
  article_review_desc: 'Unabhängige Bewertung zu Versand, QC, Kosten, Lager und Sicherheit.',
  article_shipping: 'CSSBuy Versandkosten-Guide',
  article_shipping_desc: 'Verstehen Sie Versandkosten, Methoden, Gewichtsberechnungen und Lieferzeiten.',
  article_qc: 'CSSBuy QC Guide',
  article_qc_desc: 'Lernen Sie, QC-Fotos zu lesen, Maße zu prüfen und Produktdetails zu verifizieren.',
  article_warehouse: 'CSSBuy Lager-Guide',
  article_warehouse_desc: 'Verstehen Sie Lagerung, Inspektion, Konsolidierung und Lagergebühren.',
  article_coupon: 'CSSBuy Gutschein & Rabattcode',
  article_coupon_desc: 'Wie Gutscheine und Rabattcodes funktionieren und wie man sie sicher prüft.',
  article_legit: 'Ist CSSBuy seriös?',
  article_legit_desc: 'Ein ehrlicher Blick auf Seriosität, Sicherheit und was Sie von CSSBuy erwarten können.',
  article_beginners: 'CSSBuy Spreadsheet für Anfänger',
  article_beginners_desc: 'Eine einfache Einstiegshilfe für neue CSSBuy Spreadsheet-Nutzer.',
  article_buying: 'CSSBuy Einkaufs-Guide',
  article_buying_desc: 'Schritt-für-Schritt-Anleitung für einen sicheren und informierten Einkauf.',
  article_methods: 'CSSBuy Versandmethoden',
  article_methods_desc: 'Vergleichen Sie Versandmethoden, Geschwindigkeiten und Kostenfaktoren.',
  article_qc_checklist: 'CSSBuy QC-Checkliste',
  article_qc_checklist_desc: 'Eine praktische Checkliste zur Prüfung von QC-Fotos und Details.',
  article_seller: 'CSSBuy Verkäufer-Guide',
  article_seller_desc: 'So überprüfen Sie Verkäufer und erkennen zuverlässige Quellen.',
  article_safety_guide: 'CSSBuy Sicherheits-Guide',
  article_safety_guide_desc: 'Wichtige Sicherheitsmaßnahmen zum Schutz von Konto und Geld.',
  article_faq_guide: 'CSSBuy Spreadsheet FAQ',
  article_faq_guide_desc: 'Antworten auf die häufigsten Fragen zu CSSBuy Spreadsheet.',
  read_article: 'Artikel lesen',

  // Shipping
  shipping_title: 'CSSBuy Versandkosten: Die wichtigsten Kosten verstehen',
  shipping_text: 'Die Endkosten können je nach Ziel, Gewicht, Volumen, Versandmethode, Versicherung, Verpackung und anderen Faktoren variieren. Prüfen Sie immer die aktuellen Werte, bevor Sie Ihre Bestellung bestätigen.',
  shipping_cta: 'Versand-Guide ansehen',

  // Safety
  safety_title: 'Sicherer einkaufen und recherchieren',
  safety_text: 'Überprüfen Sie Quellen, Verkäufer, Links und Informationen vor dem Kauf. Teilen Sie niemals Passwörter, Authentifizierungscodes oder Finanzinformationen mit unverifizierten Konten.',
  safety_cta: 'Sicherheitszentrum besuchen',

  // FAQ
  faq_title: 'Häufig gestellte Fragen zu CSSBuy Spreadsheet',
  faq_q1: 'Was ist CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet ist eine organisierte Ressource, die Benutzern hilft, Produkte, Kategorien, Verkäufer und Kaufinformationen vor dem Kauf über CSSBuy zu recherchieren.',
  faq_q2: 'Wie verwendet man CSSBuy Spreadsheet?',
  faq_a2: 'Beginnen Sie mit der Suche nach einem Produkt oder einer Kategorie, vergleichen Sie Informationen, überprüfen Sie Verkäuferdetails, prüfen Sie QC-Fotos und verstehen Sie Versandkosten, bevor Sie fortfahren.',
  faq_q3: 'Ist CSSBuy legitim?',
  faq_a3: 'CSSBuy ist ein bekannter Einkaufsservice. Diese Website bietet unabhängige Guides und Ressourcen, um Benutzern bei fundierten Entscheidungen zu helfen.',
  faq_q4: 'Ist CSSBuy sicher?',
  faq_a4: 'Sicherheit hängt davon ab, bewährte Praktiken zu befolgen: Verkäufer überprüfen, QC prüfen, Versand verstehen und niemals sensible Informationen teilen.',
  faq_q5: 'Wie viel kostet der Versand?',
  faq_a5: 'Versandkosten variieren je nach Ziel, Gewicht, Volumen, Methode und anderen Faktoren. Prüfen Sie immer die aktuellen Tarife vor der Bestellung.',
  faq_q6: 'Wie funktioniert das Lager?',
  faq_a6: 'Das Lager lagert Ihre Artikel, führt Inspektionen durch, macht QC-Fotos und konsolidiert Pakete vor dem Versand.',
  faq_q7: 'Was bedeutet QC?',
  faq_a7: 'QC steht für Qualitätskontrolle. Es umfasst die Überprüfung von Produktfotos, Maßen und Details, bevor der Artikel an Sie versandt wird.',
  faq_q8: 'Wie überprüft man einen Verkäufer?',
  faq_a8: 'Überprüfen Sie Verkäuferbewertungen, Rezensionen, Transaktionshistorie und verifizieren Sie Produktdetails durch mehrere Quellen vor dem Kauf.',
  faq_cta: 'Alle Fragen ansehen',

  // Final CTA
  final_cta_title: 'Bereit, Ihre Recherche zu starten?',
  final_cta_text: 'Erkunden Sie CSSBuy Spreadsheet, vergleichen Sie Informationen und konsultieren Sie unsere Guides, bevor Sie Ihre Entscheidung treffen.',
  final_cta_explore: 'CSSBuy Spreadsheet erkunden',
  final_cta_main: 'Zur Hauptseite weiterleiten',

  // Footer
  footer_tagline: 'Unabhängiger CSSBuy Spreadsheet Ressourcen-Hub',
  footer_resources: 'Ressourcen',
  footer_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  footer_cssbuy_review: 'CSSBuy Review',
  footer_cssbuy_shipping: 'CSSBuy Shipping',
  footer_cssbuy_shipping_cost: 'CSSBuy Shipping Cost',
  footer_cssbuy_qc: 'CSSBuy QC',
  footer_cssbuy_warehouse: 'CSSBuy Warehouse',
  footer_cssbuy_coupon: 'CSSBuy Coupon',
  footer_cssbuy_discount: 'CSSBuy Discount Code',
  footer_cssbuy_legit: 'CSSBuy Legit',
  footer_cssbuy_safety: 'CSSBuy Safety',
  footer_guides: 'Leitfäden',
  footer_comparisons: 'Vergleiche',
  footer_faq: 'FAQ',
  footer_legal: 'Rechtliches',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_disclaimer: 'Haftungsausschluss',
  footer_contact: 'Kontakt',
  footer_languages: 'Sprachen',
  footer_english: 'Englisch',
  footer_portuguese: 'Portugiesisch (BR)',
  footer_german: 'Deutsch',
  footer_copyright: 'cssbuybr.help ist eine unabhängige Ressource. Nicht mit CSSBuy verbunden.',

  // Trust strip
  trust_independent: 'Unabhängige Guides',
  trust_organized: 'Organisierte Information',
  trust_updated: 'Regelmäßig aktualisiert',

  // Meta
  meta_title: 'CSSBuy Spreadsheet: Guides, QC, Versand & Reviews',
  meta_description: 'Ein unabhängiger Guide zu CSSBuy Spreadsheet, Produkten, QC, Versandkosten, Lager und praktischen Einkaufstipps.',
};